<template>
  <div class="fill-height">
    <v-layout wrap>
      <v-flex>
        <v-snackbar
          v-model="dialog.snackbar"
          top
          right
          color="green">
          <span class="body-1 font-weight-light white--text"
            v-html="message.success">
          </span>

          <template v-slot:action="{ attrs }">
            <v-btn
              class="body-1 font-weight-bold text-capitalize"
              color="white"
              icon
              v-bind="attrs"
              @click="dialog.snackbar = false">
              <v-icon>mdi-close-circle-outline</v-icon>
            </v-btn>
          </template>
        </v-snackbar>

        <v-dialog 
          v-model="dialog.general"
          @keydown.esc="dialog.general = false"
          :fullscreen="dialog.fullscreen"
          width="625"
          persistent
          scrollable>
          <v-card 
            class="border-radius pa-2">
            <v-card-title 
              class="d-flex align-center py-0 px-3 text-right popup-header">
              Ubah General

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.general = false; reset();"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>

            <v-divider class="mx-4 mt-3 mb-2"/>

            <v-card-text 
              class="pt-2">
              <ValidationObserver 
                ref="form">
                <v-form>
                  <ValidationProvider 
                    name="name" 
                    rules="required" 
                    v-slot="{ errors, valid }">
                    <div class="body-2 mb-2">
                      <span class="red--text">*</span>
                      Nama Lengkap
                      <span class="error--text">
                        (wajib diisi)
                      </span>
                    </div>
                    
                    <v-text-field
                      v-on:keyup.enter="save('general')"
                      style="max-width: 70%; border-radius: 10px;"
                      filled
                      rounded
                      dense
                      single-line
                      hide-details

                      class="mb-6"
                      :color="set_color"
                      placeholder="Contoh. John Doe"
                      
                      v-model="form.name"
                      vvvv-uppercase
                      :success="form.name !== '' && valid"
                      :error-messages="errors"
                      required>
                      <template v-slot:append-outer>
                        <div v-if="errors.length > 0">
                          <v-tooltip top color="#ff5252">
                            <template v-slot:activator="{ on }">
                              <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                            </template>
                            
                            Nama Lengkap {{ errors[0] }}
                          </v-tooltip>
                        </div>

                        <div v-if="form.name !== '' && valid">
                          <v-icon color="success">mdi-check-circle-outline</v-icon>
                        </div>
                      </template>
                    </v-text-field>
                  </ValidationProvider>

                  <ValidationProvider 
                    name="username" 
                    rules="required" 
                    v-slot="{ errors, valid }">
                    <div class="body-2 mb-2">
                      <span class="red--text">*</span>
                      Username
                      <span class="error--text">
                        (wajib diisi)
                      </span>
                    </div>
                    
                    <v-text-field
                      v-on:keyup.enter="save('general')"
                      style="max-width: 50%; border-radius: 10px;"
                      filled
                      rounded
                      dense
                      single-line
                      hide-details

                      class="mb-6"
                      :color="set_color"
                      placeholder="Contoh. johndoe"
                      
                      v-model="form.username"
                      vvvv-uppercase
                      :success="form.username !== '' && valid"
                      :error-messages="errors"
                      required>
                      <template v-slot:append-outer>
                        <div v-if="errors.length > 0">
                          <v-tooltip top color="#ff5252">
                            <template v-slot:activator="{ on }">
                              <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                            </template>
                            
                            Username {{ errors[0] }}
                          </v-tooltip>
                        </div>

                        <div v-if="form.username !== '' && valid">
                          <v-icon color="success">mdi-check-circle-outline</v-icon>
                        </div>
                      </template>
                    </v-text-field>
                  </ValidationProvider>

                  <ValidationProvider 
                    name="code" 
                    rules="required" 
                    v-slot="{ errors, valid }">
                    <div class="body-2 mb-2">
                      <span class="red--text">*</span>
                      Nomor Induk Pegawai
                      <span class="error--text">
                        (wajib diisi)
                      </span>
                    </div>
                    
                    <v-text-field
                      v-on:keyup.enter="save('general')"
                      style="max-width: 40%; border-radius: 10px;"
                      filled
                      rounded
                      dense
                      single-line
                      hide-details

                      class="mb-6"
                      :color="set_color"
                      placeholder="Contoh. 001"
                      
                      v-model="form.code"
                      vvvv-uppercase
                      :success="form.code !== '' && valid"
                      :error-messages="errors"
                      required>
                      <template v-slot:append-outer>
                        <div v-if="errors.length > 0">
                          <v-tooltip top color="#ff5252">
                            <template v-slot:activator="{ on }">
                              <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                            </template>
                            
                            Nomor Induk Pegawai {{ errors[0] }}
                          </v-tooltip>
                        </div>

                        <div v-if="form.code !== '' && valid">
                          <v-icon color="success">mdi-check-circle-outline</v-icon>
                        </div>
                      </template>
                    </v-text-field>
                  </ValidationProvider>

                  <ValidationProvider 
                    name="email" 
                    rules="required|email" 
                    v-slot="{ errors, valid }">
                    <div class="body-2 mb-2">
                      <span class="red--text">*</span>
                      Email
                      <span class="error--text">
                        (wajib diisi)
                      </span>
                    </div>
                    
                    <v-text-field
                      v-on:keyup.enter="save('general')"
                      style="max-width: 60%; border-radius: 10px;"
                      filled
                      rounded
                      dense
                      single-line
                      hide-details

                      class="mb-6"
                      :color="set_color"
                      placeholder="Contoh. johndoe@gmail.com"
                      
                      v-model="form.email"
                      vvvv-uppercase
                      :success="form.email !== '' && valid"
                      :error-messages="errors"
                      required>
                      <template v-slot:append-outer>
                        <div v-if="errors.length > 0">
                          <v-tooltip top color="#ff5252">
                            <template v-slot:activator="{ on }">
                              <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                            </template>
                            
                            Email {{ errors[0] }}
                          </v-tooltip>
                        </div>

                        <div v-if="form.email !== '' && valid">
                          <v-icon color="success">mdi-check-circle-outline</v-icon>
                        </div>
                      </template>
                    </v-text-field>
                  </ValidationProvider>

                  <ValidationProvider 
                    name="mobilephone" 
                    rules="required|min:8|max:13" 
                    v-slot="{ errors, valid }">
                    <div class="body-2 mb-2">
                      <span class="red--text">*</span>
                      Telepon
                      <span class="error--text">
                        (wajib diisi)
                      </span>
                    </div>
                    
                    <v-text-field
                      v-on:keyup.enter="save('general')"
                      style="max-width: 50%; border-radius: 10px;"
                      filled
                      rounded
                      dense
                      single-line
                      hide-details

                      type="number"
                      onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                      min="0"
                      
                      class="mb-6"
                      :color="set_color"
                      placeholder="Contoh. 081332XXXXXX"
                      
                      v-model="form.mobilephone"
                      vvvv-uppercase
                      :success="form.mobilephone !== '' && valid"
                      :error-messages="errors"
                      required>
                      <template v-slot:append-outer>
                        <div v-if="errors.length > 0">
                          <v-tooltip top color="#ff5252">
                            <template v-slot:activator="{ on }">
                              <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                            </template>
                            
                            Telepon {{ errors[0] }}
                          </v-tooltip>
                        </div>

                        <div v-if="form.mobilephone !== '' && valid">
                          <v-icon color="success">mdi-check-circle-outline</v-icon>
                        </div>
                      </template>
                    </v-text-field>
                  </ValidationProvider>

                  <ValidationProvider 
                    name="address" 
                    rules="required" 
                    v-slot="{ errors, valid }">
                    <div class="body-2 mb-2">
                      <span class="red--text">*</span>
                      Alamat
                      <span class="error--text">
                        (wajib diisi)
                      </span>
                    </div>
                    
                    <v-textarea
                      v-on:keyup.enter="save('general')"
                      style="border-radius: 10px;"
                      filled
                      rounded
                      dense
                      single-line
                      hide-details

                      rows="3"

                      class="mb-6"
                      :color="set_color"
                      placeholder="Contoh. Jl"
                      
                      v-model="form.address"
                      vvvv-uppercase
                      :success="form.address !== '' && valid"
                      :error-messages="errors"
                      required>
                      <template v-slot:append-outer>
                        <div v-if="errors.length > 0">
                          <v-tooltip top color="#ff5252">
                            <template v-slot:activator="{ on }">
                              <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                            </template>
                            
                            Alamat {{ errors[0] }}
                          </v-tooltip>
                        </div>

                        <div v-if="form.address !== '' && valid">
                          <v-icon color="success">mdi-check-circle-outline</v-icon>
                        </div>
                      </template>
                    </v-textarea>
                  </ValidationProvider>

                  <ValidationProvider 
                    name="unit_id" 
                    rules="required"
                    v-slot="{ errors, valid }">
                    <div class="body-2 mb-2">
                      <span class="red--text">*</span>
                      Unit
                      <span class="error--text">
                        (wajib diisi)
                      </span>
                    </div>

                    <v-select
                      v-on:keyup.enter="save('general')"
                      style="max-width: 50%; border-radius: 10px;"
                      class="mb-6"
                      filled
                      rounded
                      dense
                      :color="set_color"
                      placeholder="Contoh. Staff"
                      hide-details
                      
                      :items="list"
                      item-text="text"
                      item-value="value"
                      :item-color="set_color"

                      v-model="form.unit_id"
                      :success="form.unit_id !== '' && valid"
                      :error-messages="errors">
                      <template v-slot:append-outer>
                        <div v-if="errors.length > 0">
                          <v-tooltip top color="#ff5252">
                            <template v-slot:activator="{ on }">
                              <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                            </template>
                            
                            Unit {{ errors[0] }}
                          </v-tooltip>
                        </div>

                        <div v-if="form.unit_id !== '' && valid">
                          <v-icon color="success">mdi-check-circle-outline</v-icon>
                        </div>
                      </template>
                    </v-select>
                  </ValidationProvider>

                  <!-- <ValidationProvider 
                    name="role" 
                    rules="required"
                    v-slot="{ errors, valid }">
                    <div class="body-2 mb-2">
                      <span class="red--text">*</span>
                      Role
                      <span class="error--text">
                        (wajib diisi)
                      </span>
                    </div>

                    <v-select
                      v-on:keyup.enter="save('general')"
                      style="max-width: 40%; border-radius: 10px;"
                      class="mb-6"
                      filled
                      rounded
                      dense
                      :color="set_color"
                      placeholder="Contoh. Staff"
                      hide-details
                      
                      :items="[
                        {
                          text: 'Staff',
                          value: 'staff'
                        },
                        {
                          text: 'Admin',
                          value: 'admin'
                        }
                      ]"
                      item-text="text"
                      item-value="value"
                      :item-color="set_color"

                      v-model="form.role"
                      :success="form.role !== '' && valid"
                      :error-messages="errors">
                      <template v-slot:append-outer>
                        <div v-if="errors.length > 0">
                          <v-tooltip top color="#ff5252">
                            <template v-slot:activator="{ on }">
                              <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                            </template>
                            
                            Role {{ errors[0] }}
                          </v-tooltip>
                        </div>

                        <div v-if="form.role !== '' && valid">
                          <v-icon color="success">mdi-check-circle-outline</v-icon>
                        </div>
                      </template>
                    </v-select>
                  </ValidationProvider> -->

                  <ValidationProvider 
                    name="position" 
                    rules="required"
                    v-slot="{ errors, valid }">
                    <div class="body-2 mb-2">
                      <span class="red--text">*</span>
                      Posisi
                      <span class="error--text">
                        (wajib diisi)
                      </span>
                    </div>

                    <!-- <v-select
                      v-on:keyup.enter="save('general')"
                      style="max-width: 50%; border-radius: 10px;"
                      filled
                      rounded
                      dense
                      :color="set_color"
                      placeholder="Contoh. Marketing"
                      hide-details
                      
                      :items="[
                        {
                          text: 'Marketing',
                          value: 'marketing'
                        },
                        {
                          text: 'Kolektor',
                          value: 'kolektor'
                        },
                        {
                          text: 'Administrasi',
                          value: 'administrasi'
                        },
                        {
                          text: 'Superadmin',
                          value: 'superadmin'
                        }
                      ]"
                      item-text="text"
                      item-value="value"
                      :item-color="set_color"

                      v-model="form.position"
                      :success="form.position !== '' && valid"
                      :error-messages="errors">
                      <template v-slot:append-outer>
                        <div v-if="errors.length > 0">
                          <v-tooltip top color="#ff5252">
                            <template v-slot:activator="{ on }">
                              <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                            </template>
                            
                            Posisi {{ errors[0] }}
                          </v-tooltip>
                        </div>

                        <div v-if="form.position !== '' && valid">
                          <v-icon color="success">mdi-check-circle-outline</v-icon>
                        </div>
                      </template>
                    </v-select> -->

                    <v-text-field
                      v-on:keyup.enter="save('general')"
                      style="max-width: 50%; border-radius: 10px;"
                      filled
                      rounded
                      dense
                      single-line
                      hide-details

                      class="mb-2"
                      :color="set_color"
                      placeholder="Contoh. Marketing"
                      
                      v-model="form.position"
                      vvvv-uppercase
                      :success="form.position !== '' && valid"
                      :error-messages="errors"
                      required>
                      <template v-slot:append-outer>
                        <div v-if="errors.length > 0">
                          <v-tooltip top color="#ff5252">
                            <template v-slot:activator="{ on }">
                              <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                            </template>
                            
                            Posisi {{ errors[0] }}
                          </v-tooltip>
                        </div>

                        <div v-if="form.position !== '' && valid">
                          <v-icon color="success">mdi-check-circle-outline</v-icon>
                        </div>
                      </template>
                    </v-text-field>
                  </ValidationProvider>
                </v-form>
              </ValidationObserver>

              <v-alert 
                type="error" 
                text dense prominent 
                class="mt-6"
                v-show="message.error.length > 0">
                {{ message.error }}
              </v-alert>
            </v-card-text>

            <v-divider class="mx-4 mb-3 mt-0"/>

            <v-card-actions>
              <v-spacer/>

              <v-btn
                :disabled="process.form"
                :loading="process.form"
                v-on:keyup.enter="save('general')"
                @click="save('general')"
                color="green"
                elevation="0"
                style="border-radius: 10px;"
                class="body-2 font-weight-bold text-capitalize white--text">
                <v-icon small class="mr-1">mdi-check-bold</v-icon>
                Simpan
              </v-btn>

              <v-btn
                :disabled="process.form"
                @click="dialog.general = false; reset();"
                outlined
                style="border-radius: 10px;"
                class="body-2 font-weight-bold text-capitalize red--text">
                <v-icon color="red" small class="mr-1">mdi-close-circle</v-icon>
                Batal
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog 
          v-model="dialog.password"
          @keydown.esc="dialog.password = false"
          :fullscreen="dialog.fullscreen"
          width="625"
          persistent
          scrollable>
          <v-card 
            class="border-radius pa-2">
            <v-card-title 
              class="d-flex align-center py-0 px-3 text-right popup-header">
              Ubah Password

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.password = false; reset();"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>

            <v-divider class="mx-4 mt-3 mb-2"/>

            <v-card-text 
              class="pt-2">
              <ValidationObserver 
                ref="form">
                <v-form>
                  <ValidationProvider 
                    name="old_password" 
                    rules="required|min:8|max:20" 
                    v-slot="{ errors, valid }">
                    <div class="body-2 mb-2">
                      <span class="red--text">*</span>
                      Password Lama
                      <span class="error--text">
                        (wajib diisi)
                      </span>
                    </div>
                    
                    <v-text-field
                      v-on:keyup.enter="save('password')"
                      style="max-width: 50%; border-radius: 10px;"
                      filled
                      rounded
                      dense
                      single-line
                      hide-details

                      class="mb-6"
                      :color="set_color"
                      placeholder="Contoh. ********"

                      :type="show.old_password ? 'text' : 'password'"
                      :append-icon="show.old_password ? 'mdi-eye' : 'mdi-eye-off'"
                      @click:append="show.old_password = !show.old_password"
                      
                      v-model="form.old_password"
                      vvvv-uppercase
                      :success="form.old_password !== '' && valid"
                      :error-messages="errors"
                      required>
                      <template v-slot:append-outer>
                        <div v-if="errors.length > 0">
                          <v-tooltip top color="#ff5252">
                            <template v-slot:activator="{ on }">
                              <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                            </template>
                            
                            Password Lama {{ errors[0] }}
                          </v-tooltip>
                        </div>

                        <div v-if="form.old_password !== '' && valid">
                          <v-icon color="success">mdi-check-circle-outline</v-icon>
                        </div>
                      </template>
                    </v-text-field>
                  </ValidationProvider>

                  <ValidationProvider 
                    name="new_password" 
                    rules="required|min:8|max:20" 
                    v-slot="{ errors, valid }">
                    <div class="body-2 mb-2">
                      <span class="red--text">*</span>
                      Password Baru
                      <span class="error--text">
                        (wajib diisi)
                      </span>
                    </div>

                    <v-text-field
                      v-on:keyup.enter="save('password')"
                      style="max-width: 50%; border-radius: 10px;"
                      filled
                      rounded
                      dense
                      single-line
                      hide-details

                      :color="set_color"
                      placeholder="Contoh. ********"

                      :type="show.new_password ? 'text' : 'password'"
                      :append-icon="show.new_password ? 'mdi-eye' : 'mdi-eye-off'"
                      @click:append="show.new_password = !show.new_password"
                      
                      v-model="form.new_password"
                      vvvv-uppercase
                      :success="form.new_password !== '' && valid"
                      :error-messages="errors"
                      required>
                      <template v-slot:append-outer>
                        <div v-if="errors.length > 0">
                          <v-tooltip top color="#ff5252">
                            <template v-slot:activator="{ on }">
                              <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                            </template>
                            
                            Password Baru {{ errors[0] }}
                          </v-tooltip>
                        </div>

                        <div v-if="form.new_password !== '' && valid">
                          <v-icon color="success">mdi-check-circle-outline</v-icon>
                        </div>
                      </template>
                    </v-text-field>
                  </ValidationProvider>
                </v-form>
              </ValidationObserver>

              <v-alert 
                type="error" 
                text dense prominent 
                class="mt-6"
                v-show="message.error.length > 0">
                {{ message.error }}
              </v-alert>
            </v-card-text>

            <v-divider class="mx-4 mb-3 mt-0"/>

            <v-card-actions>
              <v-spacer/>

              <v-btn
                :disabled="process.form"
                :loading="process.form"
                v-on:keyup.enter="save('password')"
                @click="save('password')"
                color="green"
                elevation="0"
                style="border-radius: 10px;"
                class="body-2 font-weight-bold text-capitalize white--text">
                <v-icon small class="mr-1">mdi-check-bold</v-icon>
                Simpan
              </v-btn>

              <v-btn
                :disabled="process.form"
                @click="dialog.password = false; reset();"
                outlined
                style="border-radius: 10px;"
                class="body-2 font-weight-bold text-capitalize red--text">
                <v-icon color="red" small class="mr-1">mdi-close-circle</v-icon>
                Batal
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        
        <section>
          <v-card 
            flat>
            <v-card-text 
              class="pa-0">
              <v-row>
                <v-col
                  cols="12"
                  md="2">
                  <div 
                    :class="scroll ? 'on-scroll-sticky' : 'on-scroll-ralative'" 
                    v-scroll="onScroll">
                    <div 
                      @click="$router.go(-1)"
                      class="d-flex align-center cursor-pointer mb-6"
                      style="width: 7%;">
                      <v-icon :color="set_color">mdi-arrow-left-thick</v-icon>
                  
                      <span 
                        class="body-1 ml-1 black--text"
                        style="opacity: 60%;">
                        Kembali
                      </span>
                    </div>
                    
                    <div
                      class="cover">
                      <v-skeleton-loader v-if="process.load"
                        :loading="process.load"
                        type="image"
                        style="border-radius: 30px;">
                      </v-skeleton-loader>

                      <v-img v-else
                        width="100%"
                        height="200"
                        alt="umb" 
                        :src="detail.image_url !== '' ? detail.image_url : require('@/assets/image/member_default.jpg')"
                        class="ma-auto"
                        :style="`box-shadow: ${set_color_rgb} 6px 2px 16px 0px, rgba(255, 255, 255, 0.8) -6px -2px 16px 0px;; border-radius: 30px;`">
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height"
                            align="center"
                            justify="center">
                            <v-progress-circular 
                              size="20"
                              indeterminate 
                              :color="set_color">
                            </v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                    </div>
                  </div>
                </v-col>

                <v-col
                  cols="12"
                  md="10">
                  <v-skeleton-loader v-if="process.load"
                    :loading="process.load"
                    type="article, list-item-two-line, list-item-avatar-three-line, list-item-avatar-three-line, list-item-avatar-three-line, article, list-item-two-line, list-item-three-line">
                  </v-skeleton-loader>
                  
                  <v-card v-else
                    flat>
                    <v-card-text
                      class="mt-6">
                      <v-chip
                        class="font-weight-bold white--text border-radius px-4"
                        color="#848484">
                        Nomor Induk Pegawai - {{ detail.code }}
                      </v-chip>

                      <div
                        class="text-h5 font-weight-bold black--text line-text-second my-2">
                        {{ detail.name }}
                      </div>

                      <div
                        class="d-flex align-center mb-1">
                        <v-icon size="18">mdi-email-outline</v-icon>
                        
                        <span
                          class="ml-2">
                          {{ detail.email }}
                        </span>
                      </div>

                      <div
                        class="d-flex align-center mb-6">
                        <v-icon size="18">mdi-phone-in-talk-outline</v-icon>
                        
                        <span
                          class="ml-2">
                          {{ detail.mobilephone }}
                        </span>
                      </div>

                      <div
                        class="body-2 text-capitalize d-flex align-center mb-6">
                        <div
                          class="orange--text font-weight-bold">
                          {{ detail.role }}
                        </div>

                        <div
                          class="mx-2">
                          |
                        </div>

                        <div
                          class="orange--text font-weight-bold">
                          {{ detail.position }}
                        </div>
                      </div>

                      <div
                        class="body-1 font-weight-bold black--text mb-2">
                        Alamat.
                      </div>

                      <div
                        class="mb-6">
                        {{ detail.address }}
                      </div>

                      <div
                        class="body-1 font-weight-bold black--text mb-2">
                        Unit.
                      </div>

                      <div
                        class="mb-1">
                        Nama. <span class="font-weight-bold">{{ detail.unit_name }}</span>
                      </div>

                      <div
                        class="mb-1">
                        Latlong. <span class="font-weight-bold">{{ detail.unit_latitude }}, {{ detail.unit_longitude }}</span>
                      </div>

                      <div
                        class="mb-6">
                        Range. <span class="font-weight-bold">{{ detail.unit_attended_range }}</span>
                      </div>

                      <div
                        class="mb-2 green--text">
                        Terdaftar Tanggal <span class="font-weight-bold">{{ detail.create_datetime | datetime }}</span>
                      </div>
                    </v-card-text>

                    <v-card-actions>
                      <v-btn
                        @click="dialog.general = true; reset();"
                        elevation="0"
                        style="background: #2196f333; border-radius: 10px;"
                        class="body-2 text-capitalize font-weight-bold d-flex align-center blue--text">
                        <v-icon size="18">mdi-circle-edit-outline</v-icon>

                        <span class="ml-1">
                          Ubah General
                        </span>
                      </v-btn>

                      <v-btn
                        @click="dialog.password = true; reset();"
                        elevation="0"
                        style="background: #ff980033; border-radius: 10px;"
                        class="body-2 text-capitalize font-weight-bold d-flex align-center orange--text">
                        <v-icon size="18">mdi-lock-reset</v-icon>

                        <span class="ml-1">
                          Ubah Password
                        </span>
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { get, post, put, destroy } from "@/service/Axios";
  export default {
    data () {
      return {
        scroll: false,
        dialog: {
          general: false,
          password: false,
          fullscreen: false,
          snackbar: false
        },
        show: {
          old_password: false,
          new_password: false
        },
        list: [],
        detail: {},
        form: {
          id: '',
          name: '',
          username: '',
          code: '',
          email: '',
          mobilephone: '',
          address: '',
          unit_id: '',
          role: '',
          position: '',

          // PASSWORD
          old_password: '',
          new_password: ''
        },
        process: {
          load: false,
          form: false
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      
    },
    watch: {
      
    },
    computed: {
      rps() {
        return this.$vuetify.breakpoint.name
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.48)`
      }
    },
    mounted () {
      this.fetch()
    },
    methods: {
      onScroll(e) {
        if (typeof window === 'undefined') return
        const top = window.pageYOffset || e.target.scrollTop || 0
        this.scroll = top > window.innerHeight - 1000
      },
      async fetch () {
        this.process.load = true

        await get('admin/profile/detail')
        .then(response => {
          let res = response.data

          this.process.load = false

          if (res.status === 200) {
            this.detail = res.results.data

            this.$store.commit("setUser", this.detail)
          }
        })
      },
      async fetchUnit () {
        let params = {
          limit: 100000
        }

        this.list = []

        await get('admin/unit', { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            res.results.data.map(obj => {
              this.list.push({
                text: obj.name,
                value: obj.id
              })
            })
          }
        })
      },
      reset () {
        if (this.$refs.form) this.$refs.form.reset()
        
        this.form = {
          id: this.detail.id,
          name: this.detail.name,
          username: this.detail.username,
          code: this.detail.code,
          email: this.detail.email,
          mobilephone: this.detail.mobilephone,
          address: this.detail.address,
          unit_id: this.detail.unit_id,
          role: this.detail.role,
          position: this.detail.position,

          // PASSWORD
          old_password: '',
          new_password: ''
        }

        this.process.form = false

        this.message.error = ''

        this.fetchUnit()
      },
      async save (type) {
        this.message.error = ''

        const isValid = await this.$refs.form.validate()

        if (isValid) {
          this.process.form = true

          let url = type === 'general' ? 'admin/profile/update' : 'admin/profile/change_password'

          // SAVE TO REST API
          await post(url, {
            data: this.form
          })
          .then(response => {
            let res = response.data
            
            this.process.form = false

            if (res.status === 200) {
              this.dialog.general = false
              this.dialog.password = false
              this.dialog.fullscreen = false

              this.dialog.snackbar = true
              this.message.success = res.message

              this.fetch()
            } else {
              this.message.error = res.message
            }
          })

        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      }
    }
  }
</script>

<style>
  .cover .v-skeleton-loader__image {
    height: 200px !important;
  }
</style>